import React from 'react'
import { createStackNavigator } from "@react-navigation/stack";
import AddEditBuyXgetYDiscount from '../components/discounts/buyXgetYDiscount/addEditBuyXgetYDiscount';
import ViewDiscount from '../components/discounts/shared/viewDiscount';
import CommonDiscountList from '../shared/commonComponents/commonDiscountList';

const BuyXgetYDiscount = () => <CommonDiscountList type="BuyXGetY" />

/* Functional component to hold all the pages in a stack navigator */
const BuyXgetYDiscountStack = () => {
    // Variable to handle appStack
    const AppStack = createStackNavigator();

    return (
        <AppStack.Navigator
            initialRouteName={"BuyXgetYDiscount"}
            screenOptions={{ headerShown: false, }}>
            <AppStack.Screen name="BuyXgetYDiscount" component={BuyXgetYDiscount} />
            <AppStack.Screen name="AddEditBuyXgetYDiscount" component={AddEditBuyXgetYDiscount} />
            <AppStack.Screen name="ViewDiscount" component={ViewDiscount} />
        </AppStack.Navigator>
    );
};

export default BuyXgetYDiscountStack;